import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { isDigit3mimrri4wkzop as isDigit } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import {
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  Char19o2r8palgjof as Char,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  substringBefore3n7kj60w69hju as substringBefore,
  substringAfter1hku067gwr5ve as substringAfter,
  contains2el4s70rdq4ld as contains,
  padStart36w1507hs626a as padStart,
  trimEndvvzjdhan75g as trimEnd,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  reversed3umwqsxpi431x as reversed,
  chunked3v1tthtda414w as chunked,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  reversed22y3au42jl32b as reversed_0,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { numberToLong2pakxeg38estk as numberToLong } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function commaString(_this__u8e3s4) {
  // Inline function 'kotlin.text.filter' call
  var tmp0 = toStringNoExponential(_this__u8e3s4);
  // Inline function 'kotlin.text.filterTo' call
  var destination = StringBuilder().d1();
  var inductionVariable = 0;
  var last = charSequenceLength(tmp0);
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var element = charSequenceGet(tmp0, index);
      if (isDigit(element) || setOf([new (Char())(_Char___init__impl__6a9atx(46)), new (Char())(_Char___init__impl__6a9atx(45))]).t1(new (Char())(element))) {
        destination.xb(element);
      }
    }
     while (inductionVariable < last);
  var clean = destination.toString();
  // Inline function 'kotlin.text.reversed' call
  var this_0 = substringBefore(clean, _Char___init__impl__6a9atx(46));
  var tmp = toString(reversed(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  var preDecimal = joinToString(reversed_0(chunked(tmp, 3, commaString$lambda)), ',');
  var postDecimal = substringAfter(clean, _Char___init__impl__6a9atx(46), '');
  return contains(clean, _Char___init__impl__6a9atx(46)) ? preDecimal + '.' + postDecimal : preDecimal;
}
function toStringNoExponential(_this__u8e3s4) {
  var preDecimal = numberToLong(_this__u8e3s4).toString();
  var r = _this__u8e3s4 % 1;
  if (r === 0.0)
    return preDecimal;
  var availableDigits = 10 - preDecimal.length | 0;
  // Inline function 'kotlin.math.pow' call
  var tmp$ret$0 = Math.pow(10.0, availableDigits);
  var postDecimal = roundToInt(r * tmp$ret$0);
  if (postDecimal === 0)
    return preDecimal;
  else
    return preDecimal + '.' + trimEnd(padStart(postDecimal.toString(), availableDigits, _Char___init__impl__6a9atx(48)), charArrayOf([_Char___init__impl__6a9atx(48)]));
}
function commaString$lambda(it) {
  return reversed(it);
}
//region block: exports
export {
  commaString as commaStringeuj84z632mms,
};
//endregion

//# sourceMappingURL=backspace.mjs.map
